export const defaultSorted = [{ dataField: "weekNumber", order: "desc" }];
export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "30", value: 30 },
  { text: "40", value: 40 },
  { text: "50", value: 50 },
  { text: "100", value: 100 },
];
export const initialFilter = {
  filter: {},
  sortOrder: "desc", // asc||desc
  sortField: "weekNumber",
  pageNumber: 1,
  pageSize: 10,
};

export const initValuesForecastResult = {
  success: true,
  message: "",
  fileName: "",
  exportRundown: "",
  typeName: "",
  date: new Date(),
};
